import wrlog from '../../Helper/functions/wrlog';
import Storage from '../Storage';
import Unit from './index';

export default class SearchUnit extends Unit {
    static search = async (search) => {
        return await Unit.get(`/search/${encodeURIComponent(search)}`);
    }
}